import script from "./FieldHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldHeader.vue?vue&type=script&setup=true&lang=js"

import "./FieldHeader.vue?vue&type=style&index=0&id=d53dc07e&lang=scss"

const __exports__ = script;

export default __exports__